export function roundToNearestHalf(value) {
  return Math.round(value * 2)/2;
}



// WEBPACK FOOTER //
// ./src/models/roundToNearestHalf.ts